import { useQuery } from "@tanstack/react-query";
import {
	GetMapQueryConfigurationByMapQuery,
	GetMapQueryConfigurationByMapQueryVariables,
} from "~map-tools/types/__generated/gql/graphql";
import { graphierQLNextClient } from "utils";

const query = /* GraphQL */ `
	query GetMapQueryConfigurationByMap($mapId: ID!) {
		getMapQueryConfigurationByMap(mapId: $mapId) {
			id
			createdAt
			updatedAt
			name
			description
			color
			mapId
			layerConfigurations {
				id
				title
				description
				measurementUnit
				isResultsTableEnabled
				isReportEnabled
				reportContent
				layerId
				spatialFilters {
					enabled
					allowedTypes
				}
				attributeFilters {
					propertyName
					filterType
				}
				outputSettings {
					allowedFormats
					includeGeometry
				}
				_layer {
					datasetId
					_dataset {
						type
					}
				}
			}
		}
	}
`;

export type GetMapQueryConfigurationByMapVariables =
	GetMapQueryConfigurationByMapQueryVariables;
export type GetMapQueryConfigurationByMapResults =
	GetMapQueryConfigurationByMapQuery["getMapQueryConfigurationByMap"];

export const getMapQueryConfigurationByMapQueryKey = (
	variables: GetMapQueryConfigurationByMapVariables,
) => ["getMapQueryConfigurationByMap", variables];

const getMapQueryConfigurationByMapQueryFn = async (
	variables: GetMapQueryConfigurationByMapVariables,
) => {
	return graphierQLNextClient<
		GetMapQueryConfigurationByMapQuery,
		GetMapQueryConfigurationByMapVariables
	>({
		query,
		variables,
	}).then((res) => res.getMapQueryConfigurationByMap);
};

export const useGetMapQueryConfigurationByMap = (
	variables: GetMapQueryConfigurationByMapVariables,
) => {
	return useQuery({
		enabled: !!variables.mapId,
		queryKey: getMapQueryConfigurationByMapQueryKey(variables),
		queryFn: () => getMapQueryConfigurationByMapQueryFn(variables),
	});
};
